import React from 'react';
import PageContainer from '../../components/PageComponents/layouts/PageContainer';
import SafetyNav from '../../components/SafetyNav';
import List from './List';

const breadcrumbs = [{ label: 'Skyclimber Forms', isActive: true }];

const SafetySkyclimberForms = () => (
  <PageContainer heading="SKYCLIMBER FORMS" breadcrumbs={breadcrumbs}>
    <SafetyNav />
    <List />
  </PageContainer>
);

export default SafetySkyclimberForms;
